import Vue from 'vue';
import '@/locale/index';// 国际化引入
import viewDesign from 'view-design';
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
import ko from 'view-design/dist/locale/ko-KR';
import Vuex from 'vuex';
import vueEasytable from "vue-easytable";
import directives from "@/utils/directives";
import VueViewer from 'v-viewer';
import VueVirtualScroller from 'vue-virtual-scroller';

// ueditor富文本編輯器
import '#@/static/ueditor/ueditor.config.js'; // 配置文件还是引用当前系统文件的配置

// ueditor公共的资源文件引用的是私服的依赖包
import "#@/static/ueditor/ueditor.all.js";
import "#@/static/ueditor/lang/zh-cn/zh-cn.js";
import "#@/static/ueditor/themes/default/css/ueditor.css";
import "#@/static/ueditor/themes/default/dialogbase.css";

import '@/components/localComponents/index';
import '@/utils/tools/index';
import '@/assets/http';

import 'view-design/dist/styles/iview.css';
import 'viewerjs/dist/viewer.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import '@/assets/styles/index.less';
import "vue-easytable/libs/theme-default/index.css";
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import '@/assets/styles/config.css';
import '@/assets/styles/scrollBar.css';


let useViewLocal = {
  locale: {}
};

const langMap = {
  'en-US': en,
  'zh-CN': zh,
  'ko-KR': ko
};
const storedLang = localStorage.getItem('lang');
if (storedLang && langMap[storedLang]) {
  useViewLocal.locale = langMap[storedLang];
} else {
  useViewLocal.locale = zh;
}

Vue.use(viewDesign, {
  ...useViewLocal
});
Vue.use(directives);
Vue.use(VueViewer);
Vue.use(VueVirtualScroller);

Vue.prototype.$Message.config({
  top: 50,
  duration: 5
});
Vue.use(Vuex);
Vue.use(vueEasytable);
